import { gql } from '@apollo/client';

const GET_USERS = gql`
  query users(
  $params: QueryParams
  $name: String
  $type: String
  ) {
    users(
    params: $params
    name: $name
    type: $type
    ) {
      info {
        count
      }
      results {
        id
        firstName
        lastName
      }
    }
  }
`;
const UPDATE_TICKET = gql`
  mutation updateTicket($id: ID!, $ticket: TicketUpdateInput!) {
    updateTicket(id: $id, ticket: $ticket) {
      success
      message
      ticket {
        id
      }
    }
  }
`;


export { GET_USERS, UPDATE_TICKET };
